export const ua_policies = {
  refund: {
    title: "Політика повернення",
    backToCheckout: "Назад до оформлення",
    backToHome: "Повернутися на головну",
    setupFeeNotice: "Плата за налаштування в розмірі €500 не повертається після початку розробки.",
    subscriptionNotice: "Платежі за підпискою не повертаються за оплачені періоди.",
    exceptionalCircumstances: "Виняткові обставини",
    exceptionalText: "Dathent залишає за собою право прийняття рішень у виняткових обставинах.",
    processTitle: "Процес повернення",
    processText: "Якщо ви вважаєте, що у вас є підстави для винятку з політики повернення, будь ласка, зв'яжіться з нами:",
    earlyTerminationTitle: "Дострокове розірвання",
    earlyTerminationText: "Для отримання інформації про дострокове розірвання договору за моделлю Infrastructure Commitment, будь ласка, зверніться до",
    termsLink: "Умов надання послуг",
    lastUpdated: "Останнє оновлення: Лютий 2026"
  },
  privacy: {
    title: "Політика конфіденційності",
    backToCheckout: "Назад до оформлення",
    backToHome: "Повернутися на головну",
    dataControllerTitle: "Контролер даних",
    companyName: "DATHENT SAX S.L.",
    nif: "NIF B22632632",
    address1: "Avenida Reyes Católicos 9, Bajo",
    address2: "03630 Sax (Alicante), Spain",
    dataCollectedTitle: "Дані, що збираються",
    dataCollectedText: "Ми збираємо та обробляємо наступні категорії персональних даних:",
    contactDetails: "Контактні дані (ім'я, email, телефон)",
    projectInfo: "Інформація про проект",
    commHistory: "Історія спілкування",
    purposeTitle: "Мета",
    purposeText: "Дані обробляються виключно для:",
    serviceDelivery: "Надання послуг",
    clientComm: "Спілкування з клієнтами",
    paymentProcessing: "Обробки платежів",
    operationalImprovement: "Покращення роботи",
    paymentSecurityTitle: "Безпека платежів",
    paymentSecurityText1: "Платежі обробляються через",
    paymentSecurityText2: "Dathent не зберігає інформацію про платіжні картки.",
    dataRightsTitle: "Права на дані",
    dataRightsText: "Відповідно до GDPR клієнти можуть запросити:",
    accessRight: "Доступ до своїх персональних даних",
    rectificationRight: "Виправлення неточних даних",
    erasureRight: "Видалення персональних даних",
    restrictionRight: "Обмеження обробки",
    requestsLabel: "Запити:",
    dataRetentionTitle: "Зберігання даних",
    dataRetentionText: "Персональні дані зберігаються лише стільки часу, скільки необхідно для цілей, викладених вище, або відповідно до вимог законодавства.",
    thirdPartySharingTitle: "Передача даних третім особам",
    thirdPartySharingText: "Ми не продаємо і не передаємо персональні дані третім особам, за винятком випадків, необхідних для надання послуг (наприклад, обробка платежів через Stripe).",
    contactTitle: "Контакти",
    contactText: "З усіх питань, пов'язаних з конфіденційністю, звертайтеся:",
    lastUpdated: "Останнє оновлення: Лютий 2026"
  },
  terms: {
    title: "Умови надання послуг",
    backToCheckout: "Назад до оформлення",
    backToHome: "Повернутися на головну",
    companyTitle: "1. Компанія",
    companyText: "Цей веб-сайт та пов'язані послуги управляються:",
    companyName: "DATHENT SAX S.L.",
    cif: "CIF B22632632",
    address1: "Avenida Reyes Católicos 9, Bajo",
    address2: "03630 Sax (Alicante), Spain",
    companyNote: "Послуги надаються відповідно до іспанського законодавства та зареєстровані в Торговому реєстрі Аліканте.",
    companyDesc: "Dathent надає структуровані рішення веб-інфраструктури та довгострокової технічної підтримки для бізнесу.",
    serviceModelsTitle: "2. Моделі обслуговування",
    serviceModelsText: "Dathent пропонує дві комерційні моделі:",
    fullDevTitle: "A. Модель повної розробки",
    fullDevPrice: "Одноразовий платіж: €1500",
    fullDevNoSubscription: "Без зобов'язання підписки.",
    fullDevDesc: "Ця модель включає повну доставку веб-сайту без зобов'язання довгострокової підтримки.",
    infraCommitTitle: "B. Модель інфраструктурного зобов'язання",
    infraSetup: "Початкове налаштування: €500",
    infraSupport: "Поточна підтримка інфраструктури: €50 на місяць",
    infraMinimum: "Мінімальне зобов'язання: 12 місяців",
    infraDesc: "Ця модель надає знижену ціну розробки в обмін на структуровану угоду про довгострокову підтримку.",
    infraNote: "Стандартна ставка підтримки становить €150 на місяць. Ставка €50 є договірним стимулом, пов'язаним з 12-місячним зобов'язанням.",
    commercialStructureTitle: "3. Комерційна структура",
    commercialPoint1: "Знижена плата за розробку (€500) не є окремим продуктом.",
    commercialPoint2: "Вона є частиною структурованої угоди про інфраструктуру.",
    commercialPoint3: "Економічна вартість розробки залишається €1500.",
    commercialPoint4: "Знижена вхідна ціна надається у зв'язку з 12-місячним зобов'язанням.",
    earlyTerminationTitle: "4. Дострокове розірвання",
    earlyTerminationText: "Якщо клієнт розриває угоду про підтримку до завершення 12 місяців, залишкова економічна вартість підлягає оплаті.",
    calculationTitle: "Розрахунок:",
    fullDevValue: "Повна вартість розробки: €1500",
    paidAtSetup: "Сума, сплачена при налаштуванні: €500",
    outstandingBalance: "Залишок до оплати: €1000",
    settlementNote: "Після погашення цього залишку угода про підтримку припиняється, і подальші щомісячні платежі не застосовуються.",
    deliveryFrameworkTitle: "5. Рамки доставки",
    deliveryText: "Розробка починається після підтвердження оплати та отримання необхідних матеріалів.",
    deliveryTime: "Типовий час доставки: від 1 тижня.",
    acceleratedDelivery: "Прискорена доставка може бути можливою залежно від обсягу проекту.",
    timelinesDepend: "Терміни залежать від оперативності клієнта та складності проекту.",
    intellectualPropertyTitle: "6. Інтелектуальна власність",
    ipText: "Повне право власності на розроблений веб-сайт передається після виконання економічних зобов'язань відповідно до одного з наступних варіантів:",
    ip12Months: "12-місячне інфраструктурне зобов'язання",
    ipOr: "АБО",
    ipFullPayment: "Повна оплата в розмірі €1500 загальної вартості",
    limitationTitle: "7. Обмеження відповідальності",
    limitationText: "DATHENT SAX S.L. не несе відповідальності за:",
    thirdPartyInterruptions: "Перебої в роботі сторонніх сервісів",
    hostingFailures: "Збої хостинг-провайдера",
    clientDelays: "Затримки, викликані неповними даними від клієнта",
    limitationNote: "Відповідальність обмежується вартістю придбаної послуги.",
    governingLawTitle: "8. Застосовне право",
    governingLawText: "Ці Умови регулюються законодавством Іспанії.",
    lastUpdated: "Останнє оновлення: Лютий 2026"
  },
  subscriptionPolicy: {
    title: "Угода про підписку",
    backToCheckout: "Назад до оформлення",
    backToHome: "Повернутися на головну",
    infraSupportTitle: "1. Підтримка інфраструктури",
    infraSupportText: "Послуга підтримки інфраструктури забезпечує:",
    techStability: "Технічну стабільність",
    continuousMaintenance: "Безперервне обслуговування",
    minorAdjustments: "Незначні функціональні коригування",
    monitoring: "Моніторинг та контроль продуктивності",
    standardRate: "Стандартна ставка: €150 на місяць.",
    discountedRateTitle: "2. Пільгова ставка зобов'язання",
    discountedRateText: "Ставка €50/міс надається виключно в рамках моделі Infrastructure Commitment.",
    minimumTerm: "Мінімальний строк: 12 місяців.",
    discountedRateNote: "Пільгова ставка відображає структуру довгострокової співпраці.",
    billingStructureTitle: "3. Структура біллінгу",
    billing30Days: "Біллінг починається через 30 днів після першого платежу за налаштування.",
    billingStripe: "Платежі обробляються безпечно через Stripe.",
    earlyExitTitle: "4. Умови дострокового виходу",
    earlyExitText: "При розірванні договору до закінчення 12 місяців залишкова економічна вартість у розмірі €1000 підлягає оплаті.",
    earlyExitNote: "Після погашення подальші платежі за підпискою не застосовуються.",
    postCommitmentTitle: "5. Фаза після зобов'язання",
    postCommitmentText: "Після 12 місяців угода продовжується на місячній основі.",
    postCommitmentNote: "Клієнт може розірвати договір у будь-який час без штрафних санкцій.",
    lastUpdated: "Останнє оновлення: Лютий 2026"
  },
  cookies: {
    title: "Політика використання файлів cookie",
    backToCheckout: "Назад до оформлення",
    backToHome: "Повернутися на головну",
    whatAreCookiesTitle: "Що таке файли cookie",
    whatAreCookiesText: "Файли cookie - це невеликі текстові файли, які зберігаються на вашому пристрої при відвідуванні веб-сайту. Вони допомагають веб-сайту запам'ятовувати інформацію про ваш візит.",
    essentialCookiesTitle: "Обов'язкові файли cookie",
    essentialCookiesText: "Цей веб-сайт використовує обов'язкові файли cookie, необхідні для роботи.",
    essentialCookiesNote: "Ці файли cookie необхідні для правильної роботи веб-сайту і не можуть бути вимкнені.",
    analyticsCookiesTitle: "Аналітичні файли cookie",
    analyticsCookiesText: "Аналітичні файли cookie можуть використовуватися для підвищення продуктивності та розуміння того, як відвідувачі взаємодіють з веб-сайтом.",
    analyticsCookiesNote: "Ці файли cookie допомагають нам аналізувати трафік веб-сайту та оптимізувати користувацький досвід.",
    managingCookiesTitle: "Управління файлами cookie",
    managingCookiesText: "Користувачі можуть вимкнути необов'язкові файли cookie через налаштування браузера.",
    chromeSettings: "Chrome: Налаштування → Конфіденційність та безпека → Файли cookie",
    firefoxSettings: "Firefox: Налаштування → Приватність та захист → Файли cookie",
    safariSettings: "Safari: Налаштування → Конфіденційність → Файли cookie",
    disablingNote: "Примітка: Вимкнення обов'язкових файлів cookie може вплинути на функціональність веб-сайту.",
    thirdPartyCookiesTitle: "Сторонні файли cookie",
    thirdPartyCookiesText: "Ми можемо використовувати сторонні сервіси, які встановлюють свої власні файли cookie:",
    stripeLabel: "Stripe – для обробки платежів",
    analyticsLabel: "Інструменти аналітики – для моніторингу продуктивності",
    updatesTitle: "Оновлення цієї політики",
    updatesText: "Ми можемо час від часу оновлювати цю Політику використання файлів cookie. Будь-які зміни будуть опубліковані на цій сторінці з оновленою датою редакції.",
    contactTitle: "Контакти",
    contactText: "З питань про використання нами файлів cookie, будь ласка, зв'яжіться з нами:",
    lastUpdated: "Останнє оновлення: Лютий 2026"
  }
};
